export enum ContractFilterKeys {
    STATES = 'states',
    VALID_UNTIL_FROM = 'validUntilFrom',
    VALID_UNTIL_TO = 'validUntilTo',
    SUPPLIER_IDS = 'supplierIds',
    CUSTOMER_GROUP_ID = 'customerGroupId',
    CUSTOMER_IDS = 'customerIds',
    EVERGREEN = 'evergreen',
    SEARCH_QUERY = 'searchQuery',
}

export const LUBES_CONTRACT_FILTER_KEYS = [
    ContractFilterKeys.STATES,
    ContractFilterKeys.VALID_UNTIL_FROM,
    ContractFilterKeys.VALID_UNTIL_TO,
    ContractFilterKeys.SUPPLIER_IDS,
    ContractFilterKeys.CUSTOMER_GROUP_ID,
    ContractFilterKeys.CUSTOMER_IDS,
    ContractFilterKeys.EVERGREEN,
    ContractFilterKeys.SEARCH_QUERY,
] as const;
